/* tslint:disable */
/* auto-generated angular directive proxies */
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone} from '@angular/core';
import {ProxyCmp, proxyOutputs} from './angular-component-lib/utils';

import {Components} from '@accman-shared/myselogerpro-web-components';

export declare interface MwcIcon extends Components.MwcIcon {}
@ProxyCmp({
  inputs: ['contentRaw', 'name', 'size'],
})
@Component({
  selector: 'mwc-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['contentRaw', 'name', 'size'],
})
export class MwcIcon {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}

import {Sidebar as ISidebar} from '@accman-shared/myselogerpro-web-components/dist/collection/components/sidebar/sidebar';
export declare interface MwcSidebar extends Components.MwcSidebar {}
@ProxyCmp({
  inputs: ['structure', 'structureRaw'],
})
@Component({
  selector: 'mwc-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['structure', 'structureRaw'],
  outputs: ['routingRequest'],
})
export class MwcSidebar {
  /**  */
  routingRequest!: ISidebar['routingRequest'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['routingRequest']);
  }
}

import {Tabbar as ITabbar} from '@accman-shared/myselogerpro-web-components/dist/collection/components/tabbar/tabbar';
export declare interface MwcTabbar extends Components.MwcTabbar {}
@ProxyCmp({
  inputs: ['activeItemId', 'myselogerproImg', 'structure', 'userInformations'],
})
@Component({
  selector: 'mwc-tabbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['activeItemId', 'myselogerproImg', 'structure', 'userInformations'],
  outputs: ['routingRequest'],
})
export class MwcTabbar {
  /**  */
  routingRequest!: ITabbar['routingRequest'];
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['routingRequest']);
  }
}
